/*
  Two jobs, both small, neither of which the switch itself depends on.

  1. The ?shop= entry link.
     TWO-SHOPS-ARCHITECTURE Rule 2 keeps the mode out of every URL but allows
     one shareable entry link, ?shop=lux, which sets the mode and redirects to
     the clean URL. Liquid cannot read a query string, so this is the one part
     of the mechanism that needs scripting.

     It degrades honestly: with scripting off, ?shop=lux lands on the page in
     whatever mode the visitor already had, which is the default Luggero for a
     first visit. Nothing breaks, the link just does not switch.

     The no-JavaScript shareable link, for campaigns and the sales team, is the
     redirector itself:

       /cart/update?attributes%5Beo_shop%5D=lux&return_to=/

     That works with scripting off, in an email client, anywhere. Prefer it.

  2. Persisting Rule 1.
     A product page renders as the product's own range, decided server-side, so
     the page and its header are already right on the first byte. What this
     does is make the NEXT page follow: it writes the product's range back to
     the cart attribute so the mode quietly follows the product, as §6 requires.

     If scripting is off this does not happen, and the consequence is bounded —
     the product page itself is still correct, and the visitor's stored mode is
     simply unchanged. Nothing renders in the wrong dress either way.

  Deliberately not a module and deliberately tiny: it runs on every page.
*/
(function () {
  'use strict';

  var root = document.documentElement;
  var ATTR = root.getAttribute('data-eo-shop-attribute') || 'eo_shop';
  var UPDATE = root.getAttribute('data-eo-cart-update') || '/cart/update';
  var MODES = { lux: 1, luggero: 1 };

  function updateUrl(mode, returnTo) {
    return UPDATE +
      '?attributes%5B' + encodeURIComponent(ATTR) + '%5D=' + encodeURIComponent(mode) +
      '&return_to=' + encodeURIComponent(returnTo);
  }

  /* ---------------------------------------------------------------- 1 */
  function handleEntryLink() {
    var search = window.location.search;
    if (search.indexOf('shop=') === -1) { return false; }

    var params;
    try {
      params = new URLSearchParams(search);
    } catch (e) {
      return false;
    }
    var want = (params.get('shop') || '').trim().toLowerCase();
    if (!MODES[want]) { return false; }

    /*
      Strip only the shop parameter. A campaign link carries utm_* and those
      belong to the analytics on the page we are about to land on, so they
      travel with us rather than being dropped here.
    */
    params.delete('shop');
    var rest = params.toString();
    var clean = window.location.pathname + (rest ? '?' + rest : '');

    window.location.replace(updateUrl(want, clean));
    return true;
  }

  /* ---------------------------------------------------------------- 2 */
  function persistRenderedMode() {
    var rendered = root.getAttribute('data-eo-shop-mode');
    var stored = root.getAttribute('data-eo-shop-stored');
    if (!MODES[rendered]) { return; }
    if (rendered === stored) { return; }

    /*
      A background write. No navigation, no redirect, nothing the visitor can
      see — the page they are looking at is already correct. If it fails, the
      next page simply uses the old mode, which is a stale header and not a
      wrong product.
    */
    var body = new URLSearchParams();
    body.append('attributes[' + ATTR + ']', rendered);

    if (window.fetch) {
      window.fetch(UPDATE + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
        credentials: 'same-origin',
        keepalive: true
      }).then(function () {
        root.setAttribute('data-eo-shop-stored', rendered);
      }).catch(function () { /* stale header, never a wrong page */ });
    }
  }

  /*
    The entry link redirects, so there is no point doing anything else on a
    page that is about to be replaced.
  */
  if (handleEntryLink()) { return; }
  persistRenderedMode();
}());
